import { Injectable } from "@nestjs/common";
import { RmVehicleInspection } from "../rm-vehicle-inspection.entity";
import { GrnVehicleInspectionInfo } from "./grn-vehicle.dto";
@Injectable()
export class VehicleInspectionAdapter {
    public convertDtoToEntity(inspectionInfo: GrnVehicleInspectionInfo): RmVehicleInspection {
        const entity = new RmVehicleInspection;
        entity.grnId = inspectionInfo.rmGrnId;
        entity.grnItemId = inspectionInfo.rmGrnItemId;
        entity.indentId = inspectionInfo.indentId;
        entity.supplierId = inspectionInfo.supplierId;
        entity.vehicleId = inspectionInfo.vehicleId;
        entity.vehicleInTime = inspectionInfo.vehicleInTime;
        entity.varietyOfMaterial = inspectionInfo.productId;
        entity.sealNumber = inspectionInfo.sealNumber;
        entity.vehicleCleanliness = inspectionInfo.vehicleCleanliness;
        entity.icingConditionOfMaterial = inspectionInfo.icingConditionOfMaterial;
        entity.cratesCondition = inspectionInfo.cratesCondition;
        entity.contaminationDustOrFilth = inspectionInfo.contaminationDustOrFilth;
        entity.cleanlinessOfCrates = inspectionInfo.cleanlinessOfCrates;
        entity.anySignOfInfestation = inspectionInfo.anySignOfInfestation;
        entity.remarks = inspectionInfo.remarks;
        entity.plantId = inspectionInfo.plantId;
        entity.insulationDamage = inspectionInfo.insulationDamage;
        if (entity.inspectionId) {
            entity.updatedUser = inspectionInfo.updatedUser;
        } else {
            entity.rmVINumber  = inspectionInfo.rmVINumber;
            entity.createdUser = inspectionInfo.createdUser;
        }
        return entity;
    }

    public convertEntityToDto(entity: RmVehicleInspection): GrnVehicleInspectionInfo{
        const dto = new GrnVehicleInspectionInfo;
        dto.rmGrnId = entity.grnId;
        dto.indentId = entity.indentId;
        dto.supplierId = entity.supplierId;
        dto.vehicleId = entity.vehicleId;
        dto.vehicleInTime = entity.vehicleInTime;
        dto.productId = entity.varietyOfMaterial;
        dto.sealNumber = entity.sealNumber;
        dto.vehicleCleanliness = entity.vehicleCleanliness;
        dto.icingConditionOfMaterial = entity.icingConditionOfMaterial;
        dto.cratesCondition = entity.cratesCondition;
        dto.contaminationDustOrFilth = entity.contaminationDustOrFilth;
        dto.cleanlinessOfCrates = entity.cleanlinessOfCrates;
        dto.anySignOfInfestation = entity.anySignOfInfestation;
        dto.remarks = entity.remarks;
        dto.plantId = entity.plantId;
        dto.insulationDamage = entity.insulationDamage;
        dto.rmVINumber = entity.rmVINumber;
        dto.createdUser = entity.createdUser;
        dto.updatedUser = entity.updatedUser;

        return dto;
    }
}